<template>
  <v-container fluid class="px-0 py-0">
    <div v-if="enableInform" class="pa-2">
      <v-textarea style="width: 100%" v-model="inform" label="告知" name="inform" hint="如果填写，在检查前会让填写者阅读并确认"></v-textarea>
    </div>
    <template v-if="groups.length > 0">
      <div class="pa-2">
        <span style="color: e8e8e8;font-size: 12px;display:inline-block">
          请在下面列表中选择需要车辆检查的项目，确认之后点击保存即可。
        </span>
        <v-btn small @click="onCancel" v-if="fromRouter" style="float:right">取消</v-btn>
        <v-btn small color="primary" @click="onSave" style="float:right">保存</v-btn>
      </div>
      <div v-for="(g, idx) in groups" :key="g.id" class="group">
        <div>
          <h4>
            <v-checkbox v-model="g.checked" :hide-details="true" :label="g.name" @change="onSelAll(idx)" />
          </h4>
          <p v-if="g.desc">{{ g.desc }}</p>
          <v-divider />
        </div>
        <ul style="list-style: none">
          <li v-for="opt in g.opts" :key="opt.id">
            <v-checkbox v-model="opt.checked" :hide-details="true" :label="opt.name + (opt.desc ? `（${opt.desc}）` : '')"
              @change="onSelOpt(idx)" />
          </li>
        </ul>
      </div>
      <div style="text-align: right; clear: both">
        <v-btn @click="onCancel" v-if="fromRouter">取消</v-btn>
        <v-btn color="primary" @click="onSave">保存</v-btn>
      </div>
    </template>
  </v-container>
</template>
<script>
export default {
  name: "vehicle-check-cfg",
  props: {
    cfgId: Number,
    cfg: Object
  },
  data() {
    return {
      groups: [],
      id: null,
      fromRouter: false,
      enableInform: false,
      inform: null
    };
  },
  methods: {
    onSelAll(idx) {
      let self = this,
        g = self.groups[idx];
      for (let o of g.opts) {
        o.checked = g.checked;
      }
      self.$set(self.groups, idx, g);
    },
    onSelOpt(gIdx) {
      let self = this,
        g = self.groups[gIdx],
        checked = 0;
      for (let o of g.opts) {
        if (o.checked) {
          checked++;
        }
      }
      g.checked = g.opts.length == checked;
      self.$set(self.groups, gIdx, g);
    },
    onCancel() {
      this.$router.back();
    },
    onSave() {
      let self = this,
        groups = self.groups,
        sels = [];
      for (let g of groups) {
        for (let o of g.opts) {
          if (o.checked) {
            sels.push(o.id);
          }
        }
      }
      let data = { codes: sels.join(",") };
      if (self.inform) {
        data.inform = self.inform;
      }
      self.$axios
        .post(
          `/home/admin/m/my/tenant/vehicle/check/cfg/opts/${self.id}`,
          self.$qs.stringify(data)
        )
        .then((r) => {
          if (r.data.status == "ok") {
            self.$status("保存成功～", "success");
          } else {
            self.$status(r.data.message || "保存失败～", "error");
          }
        });
    },
    init() {
      let self = this,
        id = self.$route.params._cfgId || (self.cfg ? self.cfg.cfgId : null) || self.cfgId;
      self.id = id;
      self.$axios
        .get(`/home/admin/m/my/tenant/vehicle/check/cfg/opts/${id}`)
        .then((r) => {
          if (r.data.status == "ok") {
            let groups = r.data.opts,
              sels = (r.data.message.cfgs || "").split(","), hash = {};
            self.inform = r.data.message.inform;
            for (let c of sels) {
              hash[c] = true;
            }

            for (let g of groups) {
              for (let o of g.opts) {
                o.checked = hash[o.id] || false;
                if (o.checked) {
                  g.checkedCount = (g.checkedCount || 0) + 1;
                }
              }
              g.checked = g.opts.length == g.checkedCount;
            }

            self.groups = groups;
          }
        });
      self.enableInform = self.cfg && self.cfg.enableInform;
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.group {
  padding: 8px;
  margin-bottom: 8px;
  clear: both;
}

ul li {
  float: left;
  display: block;
  width: 300px;
}
</style>
